// extracted by mini-css-extract-plugin
module.exports = {"header":"Modal_header__iRr9K","content":"Modal_content__2Tg3a","body":"Modal_body__1Jp1A","overlay":"Modal_overlay__qaOUn","inner":"Modal_inner__Sh99_"};